import { MutationTree } from 'vuex'
import { GlobalState } from '@/store/modules/global/globalTypes'
import { setDefaultStateModule } from '@/store/modules/global/globalTypes'

export const mutations: MutationTree<GlobalState> = {
  RESET_MODULE_INITIAL_STATE(_state, { rootState, moduleName, initialState }) {
    Object.assign(rootState[moduleName], setDefaultStateModule(initialState))
  }
}
